import React from 'react';
import { useIntl } from 'react-intl';
import { faChartLine } from '@fortawesome/pro-light-svg-icons/faChartLine';
import { TypedMemo } from '../../../common/types';
import { SMLEmptyState } from '../SMLEmptyState/SMLEmptyState';

const EmptyResultsComponent: React.FC = () => {
  const intl = useIntl();

  return (
    <SMLEmptyState
      icon={faChartLine}
      title={intl.formatMessage({
        id: 'app.sml.emptyResults.title',
        defaultMessage: 'No Results Found',
      })}
      description={intl.formatMessage({
        id: 'app.sml.emptyResults.description',
        defaultMessage:
          'No data is available for the selected time period. Try selecting a different date or check back later when more data becomes available.',
      })}
    />
  );
};

export const EmptyResults = TypedMemo(EmptyResultsComponent);
